import angular from "angular"

FormularioEditarUsuarioController.$inject = [
  "$scope",
  "$mdDialog",
  "UserService",
  "GroupService",
  "UserFlagService",
  "saveCallback",
  "models"
]
function FormularioEditarUsuarioController(
  $scope,
  $mdDialog,
  UserService,
  GroupService,
  UserFlagService,
  saveCallback,
  models
) {
  var self = $scope
  self.canEditForm = false

  self.user = UserService.get({ user: models[0].id }, function() {
    self.first_name = self.user.first_name
    self.last_name = self.user.last_name
    self.username = self.user.username
    self.email = self.user.email
    self.rol_id = self.user.rol_id
  })

  self.isLoading = false

  GroupService.get().$promise.then(function(data) {
    self.roles = data.results
  })

  UserFlagService.getFlagValue(function(canEditForm) {
    self.canEditForm = !canEditForm
  })

  self.confirm = function() {
    self.user.pk = self.user.id
    self.user.first_name = self.first_name
    self.user.last_name = self.last_name
    self.user.username = self.username
    self.user.email = self.email
    self.user.password = self.password
    self.user.rol_id = self.rol_id
    // console.log(user);

    saveCallback(self.user)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

angular
  .module("appModule")
  .controller("FormularioEditarUsuarioController", FormularioEditarUsuarioController)
